import PropTypes from 'prop-types';
import React from 'react';
import Img from '../../Img';

import styles from './contactsInfoPopup.scss';

const ContactBlock = ({
    name,
    phone,
    email,
    homeCourtName,
}) => (
    <div className={styles.contactBlock}>
        <p className={styles.contactName}>{name}</p>
        <p className={styles.contactRow}>
            <Img
                src="/img/v4/icon-16px-contact-phone.svg"
                className={styles.contactFooterIcon}
                alt=""
                title="Phone"
            />
            <span className={styles.contactRowText}>
                {phone && (
                    <span className={styles.contactRowTruncate}>
                        <a href={`tel:${phone}`} className={styles.link}>{phone}</a>
                    </span>
                )}
                {!phone && 'N/A'}
            </span>
        </p>
        <p className={styles.contactRow}>
            <Img
                src="/img/v4/icon-16px-contact-mail.svg"
                className={styles.contactFooterIcon}
                alt=""
                title="Email"
            />
            <span className={styles.contactRowText}>
                {email && (
                    <span className={styles.emailText}>
                        <a href={`mailto:${email}`} className={styles.link} title={email}>{email}</a>
                    </span>
                )}
                {!email && 'N/A'}
            </span>
        </p>
        <p className={styles.contactRow}>
            <Img
                src="/img/v4/icon-16px-contact-home.svg"
                className={styles.contactFooterIcon}
                alt=""
                title="Home court"
            />
            <span className={`${styles.contactRowText} ${styles.homeCourtText}`} title={homeCourtName || undefined}>
                {homeCourtName || 'N/A'}
            </span>
        </p>
    </div>
);

ContactBlock.propTypes = {
    name: PropTypes.string.isRequired,
    phone: PropTypes.string,
    email: PropTypes.string,
    homeCourtName: PropTypes.string,
};

ContactBlock.defaultProps = {
    phone: null,
    email: null,
    homeCourtName: null,
};

export default ContactBlock;
